import React from 'react';

/**
 * Avatar de iniciales (2026-07-27).
 *
 * Las listas de conversaciones y de contactos eran solo texto: todas las filas
 * se veían iguales y había que leer para encontrar a alguien. Con un avatar de
 * color estable por persona, la fila se reconoce de un vistazo.
 *
 * El color sale del propio nombre (hash), así que el mismo paciente sale
 * siempre igual sin guardar nada. Todos los tonos son fondo claro + texto
 * oscuro: así el contraste pasa de sobra sin tener que comprobar par por par.
 */
const TONOS = [
  { bg: 'bg-[#DCEAE4] dark:bg-[#1E4A3F]', fg: 'text-[#1E4A3F] dark:text-[#BFE0D3]' }, // verde casa
  { bg: 'bg-[#E0EAFB] dark:bg-[#1B3568]', fg: 'text-[#1E4278] dark:text-[#BBD2F7]' }, // azul
  { bg: 'bg-[#FBEEDA] dark:bg-[#4A3308]', fg: 'text-[#7A4A08] dark:text-[#F0D6A6]' }, // ámbar
  { bg: 'bg-[#EDE6FB] dark:bg-[#3A2560]', fg: 'text-[#4C2A85] dark:text-[#D6C6F5]' }, // morado
  { bg: 'bg-[#FBE4E8] dark:bg-[#5A1526]', fg: 'text-[#8A1C36] dark:text-[#F5C2CD]' }, // rosa
  { bg: 'bg-[#E2EDEF] dark:bg-[#1B3F45]', fg: 'text-[#1F4E57] dark:text-[#B9DDE3]' }, // teal
];

/** Hash estable y barato: el mismo nombre da siempre el mismo tono. */
function tonoDe(texto) {
  let h = 0;
  for (let i = 0; i < texto.length; i += 1) h = (h * 31 + texto.charCodeAt(i)) | 0;
  return TONOS[Math.abs(h) % TONOS.length];
}

/** Primera letra del nombre y del primer apellido. Números → últimos 2 dígitos. */
function inicialesDe(nombre) {
  const limpio = (nombre || '').trim();
  if (!limpio) return '·';
  // Teléfono sin ficha: no hay iniciales que sacar, se usan sus 2 últimos.
  if (/^[+\d\s()-]+$/.test(limpio)) {
    const digitos = limpio.replace(/\D/g, '');
    return digitos.slice(-2) || '·';
  }
  const partes = limpio.split(/\s+/).filter(Boolean);
  return (partes[0][0] + (partes[1]?.[0] || '')).toUpperCase();
}

export default function AvatarIniciales({ nombre, size = 40, className = '' }) {
  const texto = (nombre || '').trim() || '?';
  const tono = tonoDe(texto);
  return (
    <span
      aria-hidden="true"          /* el nombre va escrito al lado, no se repite */
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
      className={`shrink-0 rounded-full inline-flex items-center justify-center
        font-semibold select-none ${tono.bg} ${tono.fg} ${className}`}
    >
      {inicialesDe(texto)}
    </span>
  );
}
